import {BifrostBackendApi, BifrostBackendNestApi} from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";

const PickupDateTimeRulesProvider = {
	async findAll() {
		const res = await BifrostBackendNestApi.get("/pickup-date-time-rules", {
			params: {
				"$limit": "10000",
				tenantId: appConfig.tenantId
			}
		});

		return res.data;
	},

	async insert({
		dateFilter,
		weekDayFilter,
		shopFilter,
		departmentFilter,
		productFilter,
		pickupRanges,
		name,
		createdById,
		createdByName,
		isWhitelist,
		isActive
	}, jwtToken) {
		return BifrostBackendApi.post(`/pickup-date-time-rules`, {
			tenantId: appConfig.tenantId,
			dateFilter,
			weekDayFilter,
			shopFilter,
			departmentFilter,
			productFilter,
			pickupRanges,
			name,
			createdById,
			createdByName,
			isWhitelist,
			isActive
		}, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async delete(id, jwtToken) {
		return BifrostBackendApi.delete(`/pickup-date-time-rules/`, {
			headers: {
				Authorization: jwtToken
			},
			params: {
				id: id
			}
		});
	},

	async get(id, jwtToken) {
		return BifrostBackendApi.get(`/pickup-date-time-rules/${id}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async partialUpdate(id, data, jwtToken){
		return BifrostBackendApi.patch(`/pickup-date-time-rules/${id}?tenantId=${data.tenantId}`, data, {
			headers: {
				Authorization: jwtToken
			}
		});
	},
	async update(id, data, jwtToken) {
		return BifrostBackendApi.put(`/pickup-date-time-rules/${id}?tenantId=${data.tenantId}`, data, {
			headers: {
				Authorization: jwtToken
			}
		});
	}
};

export default Object.freeze(PickupDateTimeRulesProvider);
